/* eslint-disable no-unused-vars */
import { useState, useEffect, useCallback } from 'react';

import { parseJwt, useFetch } from '../services/transports';
import { getPrivileges, smpCompanyStatus } from '../api/authentication';
import { getUsername, getAccessToken, getPortal } from '../services/authentication';
import { portals } from '../constants';

import { useCurrentPortal } from '.';

export const usePrivilegesProvider = () => {
  const [ privileges, setPrivileges ] = useState([]);
  const username = getUsername();
  const portal = useCurrentPortal();

  const [ { data }, fetchCompanyStatus ] = useFetch(smpCompanyStatus, response => {
    setPrivileges(
      [
        ...(response?.data?.container?.statusId === 4 ? [ 1 ] : [ 0 ]),
        ...(response?.data?.container?.drugAuthorization === 1 ? [ 2 ] : [ ])
      ]
    );

    return response.data;
  });


  const [ { data: userPrivileges }, fetchPrivileges ] = useFetch(getPrivileges,
    useCallback(response => {
      const result = response?.data?.container?.privileges
        .map(i => i.privilegeId)
        .concat(response?.data?.container?.services?.map(i => i.operationId));
      setPrivileges(result ?? []);

      return result;
    }));

  useEffect(() => {
    const token = parseJwt(getAccessToken());
    if (portal === portals.STAKEHOLDER_MANAGEMENT && token?.portal === 'smp') {
      fetchCompanyStatus();
    } else if (username && token) {
      if ((portal === portals.STAKEHOLDER_OPERATION && token.portal === 'sop')
      || (portal === portals.MANAGEMENT && token.portal === 'mp')) {
        fetchPrivileges({ 'userName': username });
      }

    }
  }, [ username ]);


  return privileges;
};
